import script from "./PaymentsByCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentsByCourse.vue?vue&type=script&setup=true&lang=js"

import "./PaymentsByCourse.vue?vue&type=style&index=0&id=3671454c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3671454c"]])

export default __exports__